import type { SignalsTimeRange } from '../core';

export type { SignalsTimeRange as RelativePerformanceTimeRange } from '../core';
export {
  SIGNALS_TIME_RANGE_LIMIT as RELATIVE_PERFORMANCE_TIME_RANGE_LIMIT,
  SIGNALS_TIME_RANGES as RELATIVE_PERFORMANCE_TIME_RANGES,
} from '../core/tokens';

export const RELATIVE_PERFORMANCE_DEFAULT_TIME_RANGE: SignalsTimeRange = '3M';
export const RELATIVE_PERFORMANCE_MAX_ASSETS = 4;
export const RELATIVE_PERFORMANCE_DEFAULT_CM_ASSET_IDS = ['btc'];
export const RELATIVE_PERFORMANCE_DEFAULT_METRIC = 'PriceUSD';
